module.exports = __webpack_public_path__ + "images/help/video-calendar-9bab05eb72b51d686719f1648b887553.png";